module.exports = " <div id=search> <a href=javascript:; class=file>选择文件 <input type=file name=q id=\"\"> </a> <input type=text placeholder=法云安缦 /> <tooltip effect=scale placement=bottom content=Search> <button type=submit title=Search><i class=\"icon-search icon-white\"></i></button> </tooltip> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search.vue
// module id = 46
// module chunks = 0